import { getFontCssContent, SSR_FONTS_STYLE_ID } from '@shared/domain/utils/css'
import { cdnPath } from '@shared/domain/utils/remoteUrl'

const addScript = (src) => {
  return new Promise((resolve, reject) => {
    let shouldAppend = false
    let el = document.querySelector('script[src="' + src + '"]')
    if (!el) {
      el = document.createElement('script')
      el.type = 'text/javascript'
      el.async = true
      el.src = src
      shouldAppend = true
    } else if (el.hasAttribute('data-loaded')) {
      resolve(el)
      return
    }

    el.addEventListener('error', reject)
    el.addEventListener('abort', reject)
    el.addEventListener('load', () => {
      el.setAttribute('data-loaded', true)
      resolve(el)
    })

    if (shouldAppend) {
      document.head.appendChild(el)
    }
  })
}

const initScrolledState = () => {
  const html = document.documentElement

  const updateScrolledState = () => {
    const scrolled = window.scrollY > 10
    const hasAttr = html.hasAttribute('data-scrolled')
    if (scrolled && !hasAttr) {
      html.setAttribute('data-scrolled', '')
    } else if (!scrolled && hasAttr) {
      html.removeAttribute('data-scrolled')
    }
  }

  updateScrolledState()
  window.addEventListener('scroll', updateScrolledState, { passive: true })
  window.addEventListener('pageshow', updateScrolledState)
  requestAnimationFrame(updateScrolledState)
}

const injectFontCssFallback = () => {
  if (document.getElementById(SSR_FONTS_STYLE_ID)) return

  const content = getFontCssContent(window.mixConfig)
  if (!content) return

  const style = document.createElement('style')
  style.id = SSR_FONTS_STYLE_ID
  style.textContent = content
  document.head.appendChild(style)
}

const initDelayedHydration = () => {
  const interactionEvents = ['mousemove', 'scroll', 'keydown', 'click', 'touchstart', 'wheel']
  let alreadyAdded = false

  const loadMainBundle = () => {
    if (alreadyAdded) {
      return
    }
    alreadyAdded = true
    injectFontCssFallback()
    interactionEvents.forEach((event) => window.removeEventListener(event, loadMainBundle))
    addScript(cdnPath('/shell/client/main.js')).catch((err) =>
      /* eslint-disable-next-line no-console */
      console.error('Hydration: failed to load', err)
    )
  }

  interactionEvents.forEach((event) =>
    window.addEventListener(event, loadMainBundle, { once: true })
  )
  setTimeout(loadMainBundle, window?._delayedHydration || 6000)
}

initScrolledState()
initDelayedHydration()
